import globalStore from '@/services/global.state';
import {getRacecarChip, getRacecarLastOrder} from '../result-service';
import {RaceBuyRecords} from '../result.type';
import React from 'react';
import ResultPanel from '../components/result-panel/result-panel';
import {View} from 'react-native';
import dayjs from 'dayjs';
import RacecarResult from './result';
import {useTranslation} from 'react-i18next';
import Text from '@/components/basic/text';
import theme from '@/style';
import CarNumber from './car-number';
import {goTo} from '@/utils';

const RacecarDraw = ({
  cycleTabKey,
  drawLabel,
}: {
  cycleTabKey?: string;
  drawLabel?: string;
}) => {
  const [racecarOrder, setRacecarOrder] = React.useState<RaceBuyRecords>();
  const requestRef = React.useRef(0);
  const {t} = useTranslation();

  const getLastOrder = async (tabKey = '', requestId = 0) => {
    try {
      const res = await getRacecarChip();
      if (requestId !== requestRef.current) {
        return;
      }
      if (!res?.player) {
        setRacecarOrder(undefined);
        return;
      }
      const order = await getRacecarLastOrder(tabKey, res.player);
      if (requestId !== requestRef.current) {
        return;
      }
      setRacecarOrder(order.records?.[0]);
    } catch (_error) {
      if (requestId === requestRef.current) {
        setRacecarOrder(undefined);
      }
    }
  };

  React.useEffect(() => {
    if (!cycleTabKey || !globalStore.token) {
      requestRef.current += 1;
      setRacecarOrder(undefined);
      return;
    }
    const requestId = ++requestRef.current;
    setRacecarOrder(undefined);
    getLastOrder(cycleTabKey, requestId).then();
  }, [cycleTabKey]);

  return racecarOrder?.roundNum ? (
    <>
      <ResultPanel
        onMore={() => {
          goTo('Bets', {tag: 'Quick Race'});
        }}
        betInfo={
          <>
            <Text size="medium" fontFamily="fontInterBold" main>
              {drawLabel} {'\n'}
            </Text>
            <Text size="small" fontFamily="fontInterBold" main>
              {racecarOrder.roundNum}
            </Text>
          </>
        }
        winAmount={racecarOrder?.profit}
        betTime={
          racecarOrder?.timestamp
            ? dayjs(racecarOrder.timestamp * 1000).format('DD-MM-YYYY hh:mm A')
            : '-'
        }>
        <View style={[theme.padding.lrl, theme.padding.tops]}>
          <Text textAlign="center">{t('game-page.label.myBets')}</Text>
          <View
            style={[
              theme.flex.row,
              theme.flex.center,
              theme.padding.topl,
              theme.padding.btmxxs,
              {gap: theme.paddingSize.l},
            ]}>
            <CarNumber num={racecarOrder.item} type="square" />
          </View>
        </View>
      </ResultPanel>
      <RacecarResult
        roundNum={racecarOrder?.roundNum}
        num={+racecarOrder?.result[0]}
      />
    </>
  ) : (
    <View />
  );
};

export default RacecarDraw;
